export class BillNoUpdateRequest{
    blNo:string;
    containerId:number;
    
    constructor(blNo:string,containerId:number){
        this.blNo = blNo;
        this.containerId = containerId;
    }
}